import {
	COUNTRY_VALUE_ERROR,
	COUNTRY_VALUE_SUCCESS,
	COUNTRY_VALUE,
} from "Constant";

import axios from "axios";

function fetchCountriesJson() {
	return { type: COUNTRY_VALUE };
}

function fetchCountriesJsonSuccess(payload) {
	return { type: COUNTRY_VALUE_SUCCESS, payload };
}

function fetchCountriesJsonFailure() {
	return { type: COUNTRY_VALUE_ERROR };
}

export const fetchingCountryJson = () => async (dispatch, getState, api) => {
	dispatch(fetchCountriesJson());

	axios
		.get(
			`${process.env.REACT_APP_ROYAL_ENFIELD_URL}/node/assets/master-data/locations-master/countries.json`
		)
		.then((response) => {
			if (response.status === 200) {
				const crSymbol = [
					...new Set(
						response?.data?.map(
							(currency) => currency?.currency_symbol
						)
					),
				];
				console.log("symbols", crSymbol);
				dispatch(
					fetchCountriesJsonSuccess({
						countries: response.data,
						currencies: crSymbol,
					})
				);
			} else {
				dispatch(fetchCountriesJsonFailure());
			}
		})
		.catch((error) => {});
};
